import React from 'react';
import { Icon } from '../icon';
import { ItemLabel, ItemTrailing, MenuItemRoot } from './Menu.styled';
import { DropdownOption } from './types';
import { Tooltip } from '../tooltip';
import { DropdownSize } from './DropdownSize';

export function MenuItem<T extends React.Key>({
	icon,
	leading,
	label,
	selected,
	onSelect,
	disabled,
	value,
	message,
	trailing,
	highlighted,
	originalIndex,
	size,
}: DropdownOption<T> & { highlighted?: boolean; originalIndex?: number; size?: DropdownSize }) {
	const onClick = () => !disabled && onSelect?.();
	return <Tooltip message={message} placement={'top'}>
		<MenuItemRoot 
			onClick={onClick} 
			$selected={selected} 
			$disabled={disabled} 
			$highlighted={highlighted}
			$size={size}
			data-value={value}
			data-disabled={disabled || undefined}
			data-original-index={originalIndex}>
			{leading ?? (icon && <Icon icon={icon} />)}
			<ItemLabel $disabled={disabled}>{label}</ItemLabel>
			{trailing && <ItemTrailing onClick={event => event.stopPropagation()}>{trailing}</ItemTrailing>}
		</MenuItemRoot>
	</Tooltip>;
}
